import React, { FC, CSSProperties } from "react";

const ConfirmModal: FC<ConfirmModalProps> = ({
    isOpen,
    message,
    onConfirm,
    onCancel,
    txtConfirm = "Confirmar",
    txtCancel = "Cancelar"

}) => {
    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <p style={{ fontFamily: "'Open Sans', sans-serif", color: "#4D4D4D" }}>{message}</p>
                <div style={styles.buttons}>
                    <button onClick={onCancel} style={styles.cancelBtn}>
                        {txtCancel}
                    </button>
                    <button onClick={onConfirm} style={styles.confirmBtn}>
                        {txtConfirm}
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles: { [key: string]: CSSProperties } = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255,1)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        fontFamily: "'Open Sans', sans-serif",
    },
    modal: {
        backgroundColor: "white",
        padding: 20,
        borderRadius: 3,
        width: 280,
        maxWidth: "90%",
        textAlign: "center",
        fontFamily: "'Open Sans', sans-serif",
    },
    buttons: {
        marginTop: 20,
        display: "flex",
        justifyContent: "space-around",
    },
    confirmBtn: {
        backgroundColor: "#008866",
        color: "#FFFFFF",
        border: "none",
        // padding: "10px 20px",
        borderRadius: 3,
        cursor: "pointer",
        height: 45,
        width: 100,
        fontSize: '14px',
    },
    cancelBtn: {
        backgroundColor: "#D7D7D7",
        color: "#4D4D4D",
        border: "none",
        //padding: "10px 20px",
        borderRadius: 3,
        cursor: "pointer",
        height: 45,
        width: 100,
        fontSize: '14px',
    },
};

export { ConfirmModal };